/**
 * Textos de pantalla por idioma (español, portugués de Brasil e inglés).
 * Los textos nuevos van en locales/*.json, nunca escritos en el código.
 *
 * Idioma: el guardado por la persona (localStorage `ruttia.lang`) o el del navegador; español por defecto.
 * Interpolación: "Cuota de {{value}}" con t('clave', { value }).
 */
import { useMemo } from 'react';
import es from './locales/es.json';
import ptBR from './locales/pt-BR.json';
import en from './locales/en.json';
import { esParts, ptBRParts, enParts } from './parts';

export type Lang = 'es' | 'pt-BR' | 'en';
type Dict = Record<string, string>;
const ES = { ...es, ...esParts };
const DICTS: Record<Lang, Dict> = { es: ES, 'pt-BR': { ...ptBR, ...ptBRParts }, en: { ...en, ...enParts } };
export type TextKey = keyof typeof ES;

const detect = (): Lang => {
  try {
    const saved = localStorage.getItem('ruttia.lang');
    if (saved === 'es' || saved === 'pt-BR' || saved === 'en') return saved;
  } catch {
    /* sin almacenamiento: se usa el navegador */
  }
  const nav = (typeof navigator !== 'undefined' ? navigator.language : 'es').toLowerCase();
  if (nav.startsWith('pt')) return 'pt-BR';
  if (nav.startsWith('en')) return 'en';
  return 'es';
};

export const currentLang = (): Lang => detect();

export const translate = (lang: Lang, key: TextKey, vars?: Record<string, string | number>): string => {
  const text = DICTS[lang][key] ?? DICTS.es[key] ?? key;
  if (!vars) return text;
  return text.replace(/\{\{(\w+)\}\}/g, (_, name) => (vars[name] === undefined ? '' : String(vars[name])));
};

/** const t = useT(); t('loanTypes.title') */
export const useT = () => {
  const lang = detect();
  return useMemo(() => (key: TextKey, vars?: Record<string, string | number>) => translate(lang, key, vars), [lang]);
};
